package pl.mothdigital.neuronowi.pages.therapies.terapiaNeurotaktylna

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import pl.mothdigital.neuronowi.common.model.*
import pl.mothdigital.neuronowi.components.layouts.*

@Page
@Composable
fun TherapyNeurotactilePage() {
    TherapyPageLayout(
        content = TherapyPageContent(
            title = "Terapia neurotaktylna",
            icon = { FaBrain() },
            description = "Stymulacja układu nerwowego poprzez receptory dotykowe, wspierająca integrację odruchów pierwotnych.",
            sections = listOf(
                TherapySection(
                    title = "Czym jest terapia neurotaktylna?",
                    content = """
                        Terapia neurotaktylna to innowacyjna metoda terapeutyczna, która wykorzystuje bodźce dotykowe
                        do stymulacji układu nerwowego. Jest to specyficzna forma stymulacji, która oddziałuje na
                        receptory dotykowe skóry, mięśni i stawów, wysyłając impulsy do mózgu i wspierając integrację
                        odruchów pierwotnych oraz prawidłowy rozwój funkcji neurologicznych.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Dla kogo jest terapia neurotaktylna?",
                    content = """
                        Terapia neurotaktylna jest szczególnie polecana dla:

                        • Dzieci z zaburzeniami neurorozwojowymi
                        • Dzieci z zaburzeniami integracji sensorycznej
                        • Dzieci z opóźnionym rozwojem psychoruchowym
                        • Osób z przetrwałymi odruchami pierwotnymi
                        • Dzieci z trudnościami w nauce (dysleksja, dysgrafia, dyskalkulia)
                        • Osób z zaburzeniami napięcia mięśniowego
                        • Dzieci z zaburzeniami ze spektrum autyzmu
                        • Osób po urazach neurologicznych
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jakie korzyści przynosi terapia neurotaktylna?",
                    content = """
                        Prawidłowo prowadzona terapia neurotaktylna może przynieść wiele korzyści:

                        • Wspieranie integracji odruchów pierwotnych
                        • Normalizację napięcia mięśniowego
                        • Poprawę koordynacji ruchowej
                        • Wspieranie rozwoju funkcji poznawczych
                        • Poprawę koncentracji i uwagi
                        • Wspomaganie regulacji emocjonalnej
                        • Poprawę percepcji sensorycznej
                        • Wspieranie rozwoju motoryki małej i dużej
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jak przebiega terapia?",
                    content = """
                        Proces terapii neurotaktylnej w Centrum Terapii NeuroNowi obejmuje:

                        1. Szczegółową diagnozę - ocenę funkcji neurologicznych, obecności odruchów pierwotnych,
                           napięcia mięśniowego i innych aspektów rozwoju.

                        2. Opracowanie indywidualnego programu terapeutycznego dostosowanego do potrzeb pacjenta.

                        3. Regularne sesje terapeutyczne, podczas których terapeuta stosuje specyficzne techniki
                           dotykowe stymulujące układ nerwowy.

                        4. W niektórych przypadkach - instruktaż dla rodziców/opiekunów dotyczący kontynuowania
                           elementów terapii w domu.

                        5. Regularne wizyty kontrolne i modyfikację programu w zależności od postępów.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasze metody",
                    content = """
                        W terapii neurotaktylnej stosujemy różnorodne techniki i podejścia:

                        • Specjalistyczne techniki stymulacji dotykowej
                        • Elementy terapii integracji odruchów pierwotnych
                        • Stymulację proprioceptywną (czucie głębokie)
                        • Techniki relaksacyjne i regulujące napięcie mięśniowe
                        • Elementy integracji sensorycznej
                        • Aktywności wspierające rozwój funkcji neurologicznych
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasi specjaliści",
                    content = """
                        Terapię neurotaktylną w naszym centrum prowadzą specjaliści z przygotowaniem w zakresie
                        neurologopedii, fizjoterapii neurologicznej i integracji sensorycznej. Nasz zespół posiada
                        specjalistyczne certyfikaty i regularnie poszerza swoją wiedzę, aby zapewnić pacjentom
                        dostęp do najnowocześniejszych metod terapeutycznych opartych na badaniach naukowych.
                    """.trimIndent()
                )
            )
        )
    )
}
